import createLucideIcon from '../createLucideIcon';

const PlusSquare = createLucideIcon('PlusSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['line', { x1: '12', x2: '12', y1: '8', y2: '16', key: '10p56q' }],
  ['line', { x1: '8', x2: '16', y1: '12', y2: '12', key: '1jonct' }],
]);

export default PlusSquare;
